import {
  VALIDATE_INVITE_TOKEN_REQUESTED,
  VALIDATE_INVITE_TOKEN_SUCCESS,
  VALIDATE_INVITE_TOKEN_FAILURE,
  ACCEPT_INVITATION_REQUESTED,
  ACCEPT_INVITATION_SUCCESS,
  ACCEPT_INVITATION_FAILURE,
} from '../actions';

export const initialState = {
  isLoading: true,
  error: null,
  inviteTokenValidatedData: null,
  inviteAccepted: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case VALIDATE_INVITE_TOKEN_REQUESTED:
      return {
        ...state,
        isLoading: true,
      };

    case VALIDATE_INVITE_TOKEN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        inviteTokenValidatedData: action.payload,
      };

    case VALIDATE_INVITE_TOKEN_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case ACCEPT_INVITATION_REQUESTED:
      return {
        ...state,
        isLoading: false,
      };

    case ACCEPT_INVITATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        inviteAccepted: true,
      };

    case ACCEPT_INVITATION_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
